<template>
	<div class="like">
		<div class="section">
			<div class="list" v-for="item in likeList" @click="goDetail(item.id)">
				<img :src="item.image[0] | handleUrl" alt="">
				<div class="foot-tips">
					<div>
						<div class="title">{{item.title}}</div>
						<div class="main-tag">
							<span class="primary" v-if="item.category==1">个人转让</span>
							<span class="primary" v-else>商家出售</span>
							<span class="primary">{{item.new_old}}</span>
						</div>
						<div class="vangrid-right">
							<span class="f1452f font-5">{{item.price | formarter}}</span>
							<span>{{item.city}}</span>
						</div>
						<div style="color: #666; margin-top: 10rpx;">距离您{{item.km}}km</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['id'],
		data() {
			return {
				//猜您喜欢
				likeList: []
			}
		},
		created() {
			//精品推荐
			this.$axios.post(baseUrl + '/mobile/Fta/ftaInfo', {
				id: this.id
			}).then((res) => {
				if (res.data.code == 2) {
					this.likeList = res.data.data.ftaRecommend;
				}
			}).catch((err) => {
				console.log(err);
			});
		},
		methods: {
			goDetail(em) {
				this.$router.push({
					path: '/undeteDteil',
					query: {
						id: em
					}
				})
			}
		},
		filters: {
			formarter(value) {
				if (parseInt(value) > 1999) {
					return '面议';
				} else {
					return '¥' + value;
				}
			}
		},
		watch: {
			//监听路由变化
			'$route'(to, from) {
				this.$router.go(0);
			}
		}
	}
</script>

<style>
	@import 'like.css';

	.like .danger {
		color: #F1452F;
		border: 1px solid #F1452F;
		border-radius: 0.2rem;
		font-size: 12px;
		padding: 0 0.2rem;
	}

	.like .main-tag {
		font-size: 0.75rem;
		margin: 0.5rem 0;
	}

	.like .primary {
		color: #3ea6ef;
		border: 1px solid #3ea6ef;
		border-radius: 0.2rem;
		font-size: 12px;
		padding: 0 0.2rem;
		margin-right: 0.2rem;
	}

	.like .vangrid-right {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.like .vangrid-right span {
		margin-top: 0 !important;
	}

	.like .vangrid-right span:nth-child(2) {
		max-width: 4.5rem;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.like .vangrid-right .f1452f {
		color: #F1452F;
		font-size: 0.8rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/like/prefer.vue